// import React, { useState, useEffect } from 'react';
// import { useSelector } from 'react-redux';
// import '../../Styles/ManagementPages.css';
// import '../../Styles/CustomerManage.css';
// import { getCustomers, getCustomerById, updateCustomer } from '../../Services/Operations/ProductAPI';

// const formatDateDMY = (dateString) => {
//   if (!dateString) return 'N/A';
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   return `${day}.${month}.${year}`;
// };

// const formatDateTime = (dateString) => {
//   if (!dateString) return 'N/A';
//   const date = new Date(dateString);
//   const day = String(date.getDate()).padStart(2, '0');
//   const month = String(date.getMonth() + 1).padStart(2, '0');
//   const year = date.getFullYear();
//   const hours = String(date.getHours()).padStart(2, '0');
//   const minutes = String(date.getMinutes()).padStart(2, '0');
//   return `${day}.${month}.${year} ${hours}:${minutes}`;
// };

// const formatTime = (timeString) => {
//   if (!timeString) return 'N/A';
//   return timeString;
// };

// const SkeletonStatsCard = () => (
//   <div className="stat-card skeleton">
//     <div className="skeleton-title"></div>
//     <div className="skeleton-value"></div>
//     <div className="skeleton-subtitle"></div>
//   </div>
// );

// const SkeletonTableRow = () => (
//   <tr className="skeleton-row">
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-avatar"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-cell"></div></td>
//     <td><div className="skeleton-badge"></div></td>
//     <td><div className="skeleton-actions"></div></td>
//   </tr>
// );

// const SkeletonTable = () => (
//   <div className="table-container skeleton">
//     <table className="data-table">
//       <thead>
//         <tr>
//           <th>No.</th>
//           <th>Profile</th>
//           <th>Name</th>
//           <th>Email</th>
//           <th>Phone</th>
//           <th>Bookings</th>
//           <th>Joined</th>
//           <th>Status</th>
//           <th>Actions</th>
//         </tr>
//       </thead>
//       <tbody>
//         {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map((i) => (
//           <SkeletonTableRow key={i} />
//         ))}
//       </tbody>
//     </table>
//   </div>
// );

// const SkeletonBookingDetails = () => (
//   <div className="bookings-section skeleton">
//     <div className="skeleton-booking-header"></div>
//     <div className="skeleton-booking-table">
//       {[1, 2, 3].map((i) => (
//         <div key={i} className="skeleton-booking-row">
//           <div className="skeleton-booking-cell"></div>
//           <div className="skeleton-booking-cell"></div>
//           <div className="skeleton-booking-cell"></div>
//           <div className="skeleton-booking-cell"></div>
//         </div>
//       ))}
//     </div>
//   </div>
// );

// const CustomerReport = () => {
//   const { token } = useSelector(state => state.user);
//   const [customers, setCustomers] = useState([]);
//   const [searching, setSearching] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [searchTerm, setSearchTerm] = useState('');
//   const [editingCustomer, setEditingCustomer] = useState(null);
//   const [editForm, setEditForm] = useState({});
//   const [viewingCustomer, setViewingCustomer] = useState(null);
//   const [error, setError] = useState(null);
//   const [customerBookings, setCustomerBookings] = useState([]);
//   const [loadingBookings, setLoadingBookings] = useState(false);

//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [totalCustomers, setTotalCustomers] = useState(0);
//   const [pageSize] = useState(10);

//   const getSequentialNumber = (index) => {
//     return (currentPage - 1) * pageSize + index + 1;
//   };

//   useEffect(() => {
//     const delayDebounceFn = setTimeout(() => {
//       fetchCustomers();
//     }, 500);
//     return () => clearTimeout(delayDebounceFn);
//   }, [currentPage, searchTerm]);

//   const fetchCustomers = async () => {
//     try {
//       setSearching(true);
//       setLoading(true);
      
//       const response = await getCustomers(token, currentPage, pageSize, searchTerm);

//       if (response && response.users) {
//         const transformedCustomers = response.users.map((user, index) => ({
//           id: user._id,
//           serialNo: getSequentialNumber(index),
//           profileImage: user.profileImage,
//           name: user.name || '',
//           email: user.email || '',
//           phone: user.phone || '',
//           bookingsCount: user.bookingsCount || 0,
//           allBookings: user.allBookings || [],
//           joined: formatDateDMY(user.createdAt),
//           status: user.isVerified ? 'Active' : 'Inactive',
//           isVerified: user.isVerified,
//           walletBalance: user.walletBalance || 0,
//           role: user.role,
//         }));

//         setCustomers(transformedCustomers);
//         setTotalPages(response.totalPages || 1);
//         setTotalCustomers(response.total || 0);
//       }
//     } catch (err) {
//       setError('Failed to fetch customers.');
//     } finally {
//       setLoading(false);
//       setSearching(false);
//     }
//   };

//   const handleViewCustomer = (customer) => {
//     setViewingCustomer({
//       ...customer,
//       name: customer.name || '',
//       email: customer.email || '',
//       phone: customer.phone || '',
//       isVerified: customer.isVerified,
//       walletBalance: customer.walletBalance || 0,
//       role: customer.role || 'user',
//       profileImage: customer.profileImage,
//       bookingsCount: customer.bookingsCount || 0
//     });
    
//     setCustomerBookings(customer.allBookings || []);
//   };

//   const handleSearchChange = (e) => {
//     setSearchTerm(e.target.value);
//     setCurrentPage(1);
//   };

//   const handleExportCSV = () => {
//     if (customers.length === 0) {
//       alert('No data to export');
//       return;
//     }

//     const headers = ['Serial No.', 'ID', 'Name', 'Email', 'Phone', 'Bookings', 'Joined', 'Status'];
//     const csvData = customers.map(customer => [
//       customer.serialNo,
//       customer.id,
//       customer.name || '',
//       customer.email || '',
//       customer.phone || '',
//       customer.bookingsCount,
//       customer.joined,
//       customer.status
//     ]);

//     const csvContent = [
//       headers.join(','),
//       ...csvData.map(row => row.map(field => `"${field}"`).join(','))
//     ].join('\n');

//     const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
//     const url = window.URL.createObjectURL(blob);
//     const link = document.createElement('a');
//     link.href = url;
//     link.download = `customers-report-${new Date().toISOString().split('T')[0]}.csv`;
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//     window.URL.revokeObjectURL(url);

//     alert('CSV exported successfully!');
//   };

//   const handleEditCustomer = (customer) => {
//     setEditingCustomer(customer.id);
//     setEditForm({
//       name: customer.name || '',
//       email: customer.email || '',
//       phone: customer.phone || '',
//       status: customer.status
//     });
//   };

//   const handleSaveEdit = async () => {
//     try {
//       setError(null);

//       const updateData = {
//         name: editForm.name,
//         email: editForm.email,
//         phone: editForm.phone,
//         isVerified: editForm.status === 'Active'
//       };

//       const response = await updateCustomer(editingCustomer, updateData, token);

//       if (response.success) {
//         setCustomers(prevCustomers =>
//           prevCustomers.map(customer =>
//             customer.id === editingCustomer ? {
//               ...customer,
//               name: response.data?.name || editForm.name,
//               email: response.data?.email || editForm.email,
//               phone: response.data?.phone || editForm.phone,
//               status: editForm.status,
//               isVerified: response.data?.isVerified || (editForm.status === 'Active')
//             } : customer
//           )
//         );

//         setEditingCustomer(null);
//         setEditForm({});
//         alert('Customer updated successfully!');
//       } else {
//         throw new Error(response.message || 'Failed to update customer');
//       }
//     } catch (err) {
//       console.error('Error updating customer:', err);
//       setError('Failed to update customer. Please try again.');
//       alert('Failed to update customer. Please try again.');
//     }
//   };

//   const handleCancelEdit = () => {
//     setEditingCustomer(null);
//     setEditForm({});
//     setError(null);
//   };

//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setEditForm(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   const closeViewModal = () => {
//     setViewingCustomer(null);
//   };

//   const handleRefresh = () => {
//     setSearchTerm('');
//     setCurrentPage(1);
//   };

//   const handleNextPage = () => {
//     if (currentPage < totalPages) {
//       setCurrentPage(prev => prev + 1);
//     }
//   };

//   const handlePrevPage = () => {
//     if (currentPage > 1) {
//       setCurrentPage(prev => prev - 1);
//     }
//   };

//   const handlePageClick = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getBookingStatusBadge = (status) => {
//     const statusMap = {
//       'confirmed': 'success',
//       'pending': 'warning',
//       'cancelled': 'danger',
//       'success': 'success',
//       'failed': 'danger'
//     };
    
//     const badgeClass = statusMap[status?.toLowerCase()] || 'secondary';
//     return (
//       <span className={`status-badge ${badgeClass}`}>
//         {status || 'N/A'}
//       </span>
//     );
//   };

//   const getPaymentStatusBadge = (status) => {
//     const statusMap = {
//       'success': 'success',
//       'pending': 'warning',
//       'failed': 'danger',
//       'refunded': 'info'
//     };
    
//     const badgeClass = statusMap[status?.toLowerCase()] || 'secondary';
//     return (
//       <span className={`status-badge ${badgeClass}`}>
//         {status || 'N/A'}
//       </span>
//     );
//   };

//   const formatCurrency = (amount) => {
//     return new Intl.NumberFormat('en-IN', {
//       style: 'currency',
//       currency: 'INR',
//       minimumFractionDigits: 0,
//       maximumFractionDigits: 0
//     }).format(amount || 0);
//   };

//   const getJourneyTime = (booking) => {
//     if (booking.route?.origin?.timings) {
//       const timing = booking.route.origin.timings[0];
//       return timing?.departureTime || 'N/A';
//     }
//     return 'N/A';
//   };

//   if (loading && customers.length === 0) {
//     return (
//       <div className="management-page">
//         <div className="page-header">
//           <div className="skeleton-header-title"></div>
//           <div className="header-actions">
//             <div className="skeleton-search"></div>
//             <div className="skeleton-button"></div>
//             <div className="skeleton-button"></div>
//           </div>
//         </div>
//         <div className="stats-cards">
//           {[1, 2, 3, 4].map((i) => (
//             <SkeletonStatsCard key={i} />
//           ))}
//         </div>
//         <SkeletonTable />
//         <div className="pagination-container">
//           <div className="skeleton-pagination-info"></div>
//           <div className="skeleton-pagination-controls"></div>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="management-page">
//       <div className="page-header">
//         <h1>Customer Report</h1>
//         <div className="header-actions">
//           <div style={{ position: 'relative' }}>
//             <input
//               type="text"
//               placeholder="Search customers by name, email or phone..."
//               className="search-input"
//               value={searchTerm}
//               onChange={handleSearchChange}
//               style={{ width: "70%" }}
//             />
//             {searching && (
//               <span style={{
//                 position: 'absolute', right: '10px', top: '50%',
//                 transform: 'translateY(-50%)', fontSize: '12px', color: '#888'
//               }}>
//                 searching...
//               </span>
//             )}
//           </div>
//           <button className="refresh-btn" onClick={handleRefresh}>
//             Refresh
//           </button>
//           <button className="export-btn" onClick={handleExportCSV}>
//             Export CSV
//           </button>
//         </div>
//       </div>

//       {error && (
//         <div className="error-message">
//           {error}
//         </div>
//       )}

//       <div className="stats-cards">
//         <div className="stat-card">
//           <h3>Total Customers</h3>
//           <p>{totalCustomers || customers.length}</p>
//           <span>All registered customers</span>
//         </div>
//         <div className="stat-card">
//           <h3>Active Customers</h3>
//           <p>{customers.filter(c => c.status === 'Active').length}</p>
//           <span>Active on current page</span>
//         </div>
//         <div className="stat-card">
//           <h3>Verified Users</h3>
//           <p>{customers.filter(c => c.isVerified).length}</p>
//           <span>verified accounts</span>
//         </div>
//         <div className="stat-card">
//           <h3>Search Results</h3>
//           <p>{customers.length}</p>
//           <span>customers found</span>
//         </div>
//       </div>

//       <div className="table-container">
//         <table className="data-table">
//           <thead>
//             <tr>
//               <th>No.</th>
//               <th>Profile</th>
//               <th>Name</th>
//               <th>Email</th>
//               <th>Phone</th>
//               <th>Bookings</th>
//               <th>Joined</th>
//               <th>Status</th>
//               <th>Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {customers.map(customer => (
//               <tr key={customer.id}>
//                 <td>{customer.serialNo}</td>
//                 <td>
//                   <div className="profile-image-cell">
//                     <img
//                       src={`${process.env.REACT_APP_BASE_URL}/uploads/${customer.profileImage}`}
//                       alt={customer.name || 'Customer'}
//                       className="customer-avatar"
//                       onError={(e) => {
//                         e.target.onerror = null;
//                       }}
//                     />
//                   </div>
//                 </td>
//                 <td>
//                   {editingCustomer === customer.id ? (
//                     <input
//                       type="text"
//                       name="name"
//                       value={editForm.name || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     customer.name || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingCustomer === customer.id ? (
//                     <input
//                       type="email"
//                       name="email"
//                       value={editForm.email || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     customer.email || 'N/A'
//                   )}
//                 </td>
//                 <td>
//                   {editingCustomer === customer.id ? (
//                     <input
//                       type="text"
//                       name="phone"
//                       value={editForm.phone || ''}
//                       onChange={handleInputChange}
//                       className="edit-input"
//                     />
//                   ) : (
//                     customer.phone || 'N/A'
//                   )}
//                 </td>
//                 <td>{customer.bookingsCount}</td>
//                 <td>{customer.joined}</td>
//                 <td>
//                   {editingCustomer === customer.id ? (
//                     <select
//                       name="status"
//                       value={editForm.status || ''}
//                       onChange={handleInputChange}
//                       className="edit-select"
//                     >
//                       <option value="Active">Active</option>
//                       <option value="Inactive">Inactive</option>
//                     </select>
//                   ) : (
//                     <span className={`status-badge ${customer.status ? customer.status.toLowerCase() : 'inactive'}`}>
//                       {customer.status || 'Inactive'}
//                     </span>
//                   )}
//                 </td>
//                 <td>
//                   {editingCustomer === customer.id ? (
//                     <div className="edit-actions">
//                       <button className="action-btn save" onClick={handleSaveEdit}>
//                         Save
//                       </button>
//                       <button className="action-btn cancel" onClick={handleCancelEdit}>
//                         Cancel
//                       </button>
//                     </div>
//                   ) : (
//                     <div className="action-buttons">
//                       <button
//                         className="action-btn view"
//                         onClick={() => handleViewCustomer(customer)}
//                       >
//                         View
//                       </button>
//                       <button
//                         className="action-btn edit"
//                         onClick={() => handleEditCustomer(customer)}
//                       >
//                         Edit
//                       </button>
//                     </div>
//                   )}
//                 </td>
//               </tr>
//             ))}
//           </tbody>
//         </table>

//         {customers.length === 0 && !loading && (
//           <div className="no-data">
//             <p>No customers found matching your search.</p>
//           </div>
//         )}
//       </div>

//       <div className="pagination-container">
//         <div className="pagination-info">
//           Showing {customers.length} of {totalCustomers} customers (Page {currentPage} of {totalPages})
//           {searchTerm && <span className="filtered-indicator"> • Search: "{searchTerm}"</span>}
//         </div>
//         <div className="pagination-controls">
//           <button
//             className="pagination-btn"
//             onClick={handlePrevPage}
//             disabled={currentPage === 1}
//           >
//             Previous
//           </button>
//           <div className="page-numbers">
//             {Array.from({ length: Math.min(5, totalPages) }, (_, i) => {
//               let pageNumber;
//               if (totalPages <= 5) {
//                 pageNumber = i + 1;
//               } else if (currentPage <= 3) {
//                 pageNumber = i + 1;
//               } else if (currentPage >= totalPages - 2) {
//                 pageNumber = totalPages - 4 + i;
//               } else {
//                 pageNumber = currentPage - 2 + i;
//               }
//               return (
//                 <button
//                   key={pageNumber}
//                   className={`page-number ${pageNumber === currentPage ? 'active' : ''}`}
//                   onClick={() => handlePageClick(pageNumber)}
//                 >
//                   {pageNumber}
//                 </button>
//               );
//             })}
//           </div>
//           <button
//             className="pagination-btn"
//             onClick={handleNextPage}
//             disabled={currentPage === totalPages}
//           >
//             Next
//           </button>
//         </div>
//       </div>

//       {viewingCustomer && (
//         <div className="modal-overlay" onClick={closeViewModal}>
//           <div className="modal-content1" onClick={(e) => e.stopPropagation()}>
//             <div className="modal-header">
//               <h3>Customer Details</h3>
//               <button className="modal-close-btn" onClick={closeViewModal}>
//                 ×
//               </button>
//             </div>
//             <div className="modal-body">
//               {loadingBookings ? (
//                 <SkeletonBookingDetails />
//               ) : (
//                 <>
//                   <div className="customer-details">
//                     <div className="customer-profile-image">
//                       <img
//                         src={viewingCustomer.profileImage ? 
//                           `${process.env.REACT_APP_BASE_URL}/uploads/${viewingCustomer.profileImage}` : 
//                           ''}
//                         alt={''}
//                         className="profile-image-large"
//                         onError={(e) => {
//                           e.target.onerror = null;
//                           e.target.src = '/default-avatar.png';
//                         }}
//                       />
//                     </div>
//                     <div className="detail-row">
//                       <label>Name:</label>
//                       <span>{viewingCustomer.name || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Email:</label>
//                       <span>{viewingCustomer.email || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Phone:</label>
//                       <span>{viewingCustomer.phone || 'N/A'}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Total Bookings:</label>
//                       <span>{viewingCustomer.bookingsCount || 0}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Joined Date:</label>
//                       <span>{viewingCustomer.joined}</span>
//                     </div>
//                     <div className="detail-row">
//                       <label>Status:</label>
//                       <span className={`status-badge ${viewingCustomer.status ? viewingCustomer.status.toLowerCase() : 'inactive'}`}>
//                         {viewingCustomer.status || 'Inactive'}
//                       </span>
//                     </div>
//                   </div>

//                   <div className="bookings-section">
//                     <h4>Customer Bookings ({viewingCustomer.bookingsCount || 0})</h4>
                    
//                     {customerBookings.length > 0 ? (
//                       <div className="bookings-table-container">
//                         <table className="bookings-table">
//                           <thead>
//                             <tr>
//                               <th>PNR Number</th>
//                               <th>Booking Date</th>
//                               <th>Booking Time</th>
//                               <th>Journey Date</th>
//                               <th>Journey Time</th>
//                               <th>Bus</th>
//                               <th>Route</th>
//                               <th>Seats</th>
//                               <th>Amount</th>
//                               <th>Status</th>
//                               <th>Payment</th>
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {customerBookings.map((booking, index) => (
//                               <tr key={booking._id || index}>
//                                 <td className="pnr">{booking.pnr || 'N/A'}</td>
//                                 <td>{formatDateDMY(booking.createdAt)}</td>
//                                 <td>{formatDateTime(booking.createdAt).split(' ')[1] || 'N/A'}</td>
//                                 <td>{formatDateDMY(booking.journeyDate)}</td>
//                                 <td>{getJourneyTime(booking)}</td>
//                                 <td>
//                                   <div>
//                                     <div><strong>{booking.bus?.busName || 'N/A'}</strong></div>
//                                     <small>{booking.bus?.busNumber || ''}</small>
//                                     <div><small>{booking.bus?.busType || ''}</small></div>
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div>
//                                     <div>{booking.route?.routeName || 'N/A'}</div>
//                                     {booking.route?.origin && (
//                                       <small>
//                                         {booking.route.origin.city || booking.route.origin} → 
//                                         {booking.route.destination?.city || booking.route.destination}
//                                       </small>
//                                     )}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="seats-list">
//                                     {booking.seats?.slice(0, 3).map((seat, idx) => (
//                                       <span key={idx} className="seat-badge">
//                                         {seat.seatNumber}
//                                       </span>
//                                     ))}
//                                     {booking.seats?.length > 3 && (
//                                       <span className="more-seats">
//                                         +{booking.seats.length - 3} more
//                                       </span>
//                                     )}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   {booking.pricing ? (
//                                     <div>
//                                       <div><strong>{formatCurrency(booking.pricing.payableAmount)}</strong></div>
//                                       <div className="booking-details-small">
//                                         <small>Total: {formatCurrency(booking.pricing.totalAmount)}</small>
//                                       </div>
//                                     </div>
//                                   ) : 'N/A'}
//                                 </td>
//                                 <td>{getBookingStatusBadge(booking.status)}</td>
//                                 <td>{getPaymentStatusBadge(booking.paymentStatus)}</td>
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
                        
//                         {customerBookings.length > 0 && (
//                           <div className="booking-summary">
//                             <div className="summary-item">
//                               <span>Total Bookings:</span>
//                               <strong>{customerBookings.length}</strong>
//                             </div>
//                             <div className="summary-item">
//                               <span>Total Amount:</span>
//                               <strong>
//                                 {formatCurrency(customerBookings.reduce((total, booking) => 
//                                   total + (booking.pricing?.payableAmount || 0), 0))}
//                               </strong>
//                             </div>
//                             <div className="summary-item">
//                               <span>Confirmed:</span>
//                               <strong>
//                                 {customerBookings.filter(b => 
//                                   b.status?.toLowerCase() === 'confirmed' || 
//                                   b.status?.toLowerCase() === 'success'
//                                 ).length}
//                               </strong>
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ) : (
//                       <div className="no-bookings">
//                         <p>No bookings found for this customer.</p>
//                       </div>
//                     )}
//                   </div>
//                 </>
//               )}
//             </div>
//             <div className="modal-footer">
//               <button className="modal-close-btn secondary" onClick={closeViewModal}>
//                 Close
//               </button>
//             </div>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// };

// export default CustomerReport;

import React, { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import '../../Styles/ManagementPages.css';
import '../../Styles/PrimaryRouteManage.css';   // base "prm-" design
import '../../Styles/PrimaryBusOwner.css';      // shared additions (avatar, pagination…)
import '../../Styles/CustomerReport.css';       // customer-only additions (load LAST)
import { getCustomers, updateCustomer } from '../../Services/Operations/ProductAPI';
import { Icon, BusSvg, StatCard, Field, Avatar, Pagination } from './PrimaryUI';

// ---------- helpers ----------
const pad = (n) => String(n).padStart(2, '0');
const formatDateDMY = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getDate())}.${pad(x.getMonth() + 1)}.${x.getFullYear()}`;
};
const formatTimeHM = (d) => {
  if (!d) return 'N/A';
  const x = new Date(d);
  return `${pad(x.getHours())}:${pad(x.getMinutes())}`;
};
const formatCurrency = (amount) =>
  new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(amount || 0);

const getJourneyTime = (b) => b.route?.origin?.timings?.[0]?.departureTime || 'N/A';
const imgUrl = (p) => (p ? `${process.env.REACT_APP_BASE_URL}/uploads/${p}` : '');

const tone = (status) => {
  const s = (status || '').toLowerCase();
  if (['confirmed', 'success'].includes(s)) return 'active';
  if (['pending'].includes(s)) return 'pending';
  if (['cancelled', 'failed'].includes(s)) return 'inactive';
  if (s === 'refunded') return 'info';
  return 'inactive';
};
const StatusPill = ({ value }) => <span className={`prm-status ${tone(value)}`}>{value || 'N/A'}</span>;

// ============================================================
// Customer card
// ============================================================
const CustomerCard = ({ c, index, onView, onEdit }) => (
  <div className={`prm-card cr-card ${c.status === 'Active' ? '' : 'inactive'}`} style={{ animationDelay: `${index * 70}ms` }}>
    <div className="prm-card-top">
      <div className="pbo-owner-id">
        <Avatar name={c.name} src={imgUrl(c.profileImage)} size={52} />
        <div>
          <div className="prm-card-no">Customer #{String(c.serialNo).padStart(2, '0')}</div>
          <h3 className="prm-card-title">{c.name || 'N/A'}</h3>
          <div className="prm-card-sub"><Icon name="calendar" size={14} /> Joined {c.joined}</div>
        </div>
      </div>
      <span className={`prm-status ${c.status === 'Active' ? 'active' : 'inactive'}`}>{c.status}</span>
    </div>
    <div className="pbo-contact">
      <div><Icon name="mail" size={14} /> {c.email || 'N/A'}</div>
      <div><Icon name="phone" size={14} /> {c.phone || 'N/A'}</div>
    </div>
    <div className="prm-metrics">
      <div className="prm-metric"><div className="v"><Icon name="ticket" size={15} /> {c.bookingsCount}</div><div className="l">Bookings</div></div>
      <div className="prm-metric"><div className="v"><Icon name="wallet" size={15} /> {formatCurrency(c.walletBalance)}</div><div className="l">Wallet</div></div>
      <div className="prm-metric"><div className="v"><Icon name={c.isVerified ? 'check' : 'info'} size={15} /> {c.isVerified ? 'Yes' : 'No'}</div><div className="l">Verified</div></div>
    </div>
    <div className="pbo-card-actions">
      <button className="prm-btn view sm" onClick={() => onView(c)}><Icon name="eye" size={14} /> View</button>
      <button className="prm-btn ghost sm" onClick={() => onEdit(c)}><Icon name="edit" size={14} /> Edit</button>
    </div>
  </div>
);

// ============================================================
// MAIN
// ============================================================
const CustomerReport = () => {
  const { token } = useSelector(state => state.user);

  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [firstLoad, setFirstLoad] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [statusFilter, setStatusFilter] = useState('all');   // applies to the current page
  const [layout, setLayout] = useState('table');

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [totalCustomers, setTotalCustomers] = useState(0);
  const totalPages = Math.max(1, Math.ceil(totalCustomers / pageSize));

  const [viewingCustomer, setViewingCustomer] = useState(null);
  const [editing, setEditing] = useState(null);   // customer being edited
  const [editForm, setEditForm] = useState({});
  const [saving, setSaving] = useState(false);

  // ---------- fetch (debounced, server-side paging + search) ----------
  useEffect(() => {
    const t = setTimeout(fetchCustomers, 400);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, searchTerm]);

  const fetchCustomers = async () => {
    try {
      setLoading(true);
      setError(null);
      const res = await getCustomers(token, currentPage, pageSize, searchTerm);
      if (res && res.users) {
        setCustomers(res.users.map((u, i) => ({
          id: u._id,
          serialNo: (currentPage - 1) * pageSize + i + 1,
          profileImage: u.profileImage,
          name: u.name || '',
          email: u.email || '',
          phone: u.phone || '',
          bookingsCount: u.bookingsCount || 0,
          allBookings: u.allBookings || [],
          joined: formatDateDMY(u.createdAt),
          status: u.isVerified ? 'Active' : 'Inactive',
          isVerified: u.isVerified,
          walletBalance: u.walletBalance || 0,
          role: u.role
        })));
        setTotalCustomers(res.total || 0);
      }
    } catch (err) {
      setError('Failed to fetch customers.');
    } finally {
      setLoading(false);
      setFirstLoad(false);
    }
  };

  // keep the page valid if the total shrinks
  useEffect(() => { if (currentPage > totalPages) setCurrentPage(totalPages); }, [currentPage, totalPages]);

  const visible = useMemo(() => customers.filter(c =>
    statusFilter === 'all' ? true : statusFilter === 'active' ? c.status === 'Active' : c.status !== 'Active'
  ), [customers, statusFilter]);

  const activeOnPage = customers.filter(c => c.status === 'Active').length;
  const verifiedOnPage = customers.filter(c => c.isVerified).length;

  // ---------- handlers ----------
  const handleExportCSV = () => {
    if (customers.length === 0) return toast.warning('No data to export');
    const headers = ['Serial No.', 'ID', 'Name', 'Email', 'Phone', 'Bookings', 'Joined', 'Status'];
    const rows = customers.map(c => [c.serialNo, c.id, c.name, c.email, c.phone, c.bookingsCount, c.joined, c.status]);
    const csv = [headers.join(','), ...rows.map(r => r.map(f => `"${String(f ?? '').replace(/"/g, '""')}"`).join(','))].join('\n');
    const url = window.URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8;' }));
    const a = document.createElement('a');
    a.href = url;
    a.download = `customers-report-${new Date().toISOString().split('T')[0]}.csv`;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
    toast.success('CSV exported successfully');
  };

  const openEdit = (c) => {
    setEditing(c);
    setEditForm({ name: c.name, email: c.email, phone: c.phone, status: c.status });
  };

  const handleSaveEdit = async () => {
    if (!editForm.name?.trim()) return toast.error('Name is required');
    try {
      setSaving(true);
      const res = await updateCustomer(editing.id, {
        name: editForm.name, email: editForm.email, phone: editForm.phone,
        isVerified: editForm.status === 'Active'
      }, token);
      if (res.success) {
        setCustomers(prev => prev.map(c => c.id === editing.id ? {
          ...c,
          name: res.data?.name || editForm.name,
          email: res.data?.email || editForm.email,
          phone: res.data?.phone || editForm.phone,
          status: editForm.status,
          isVerified: editForm.status === 'Active'
        } : c));
        toast.success('Customer updated successfully');
        setEditing(null);
      } else {
        throw new Error(res.message || 'Failed to update customer');
      }
    } catch (err) {
      console.error('Error updating customer:', err);
      toast.error('Failed to update customer. Please try again.');
    } finally {
      setSaving(false);
    }
  };

  const handleRefresh = () => {
    setSearchTerm(''); setStatusFilter('all'); setCurrentPage(1);
    fetchCustomers();
  };

  const bookings = viewingCustomer?.allBookings || [];
  const bookingTotal = bookings.reduce((t, b) => t + (b.pricing?.payableAmount || 0), 0);
  const bookingConfirmed = bookings.filter(b => ['confirmed', 'success'].includes(b.status?.toLowerCase())).length;

  // ============================================================
  if (firstLoad && loading) {
    return (
      <div className="prm-page">
        <div className="prm-hero"><div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Customers</span>
          <h1>Customer Report</h1><p>Loading customers…</p>
        </div></div>
        <div style={{ height: 24 }} />
        <div className="prm-grid">{[0, 1, 2].map(i => <div className="prm-skel" key={i}><div className="w40" /><div className="w60" /><div className="big" /><div /><div className="w60" /></div>)}</div>
      </div>
    );
  }

  return (
    <div className="prm-page">
      {/* HERO */}
      <div className="prm-hero">
        <div className="prm-hero-road" aria-hidden="true"><span className="prm-hero-roadbus"><BusSvg size={46} /></span></div>
        <div className="prm-hero-text">
          <span className="prm-eyebrow"><Icon name="users" size={13} /> Customer Insights</span>
          <h1>Customer Report</h1>
          <p>Browse registered customers, review their bookings and keep account details up to date.</p>
        </div>
        <div className="prm-hero-actions">
          <div className="prm-search">
            <Icon name="search" size={17} />
            <input type="text" placeholder="Search by name, email or phone…" value={searchTerm}
              onChange={(e) => { setSearchTerm(e.target.value); setCurrentPage(1); }} />
            {searchTerm && <button className="prm-search-clear" onClick={() => { setSearchTerm(''); setCurrentPage(1); }}>×</button>}
          </div>
          <button className="pbo-icon-btn" onClick={handleRefresh} title="Refresh"><Icon name="refresh" size={17} /></button>
          <button className="prm-add-btn" onClick={handleExportCSV}>
            <span className="plus"><Icon name="download" size={14} /></span> Export CSV
          </button>
        </div>
      </div>

      {error && <div className="cr-error"><Icon name="info" size={16} /> {error}
        <button className="prm-btn ghost sm" onClick={fetchCustomers}>Retry</button></div>}

      {/* STATS */}
      <div className="prm-stats">
        <StatCard icon="users" tone="indigo" label="Total Customers" value={totalCustomers || customers.length} hint="All registered customers" delay={80} />
        <StatCard icon="check" tone="green" label="Active" value={activeOnPage} hint="Active on this page" delay={160} />
        <StatCard icon="tick" tone="amber" label="Verified" value={verifiedOnPage} hint="Verified on this page" delay={240} />
        <StatCard icon="search" tone="cyan" label="Search Results" value={customers.length} hint="Customers on this page" delay={320} />
      </div>

      {/* TOOLBAR */}
      <div className="prm-toolbar">
        <div className="prm-toolbar-left">
          <div className="prm-chips">
            {[['all', 'All', customers.length], ['active', 'Active', activeOnPage], ['inactive', 'Inactive', customers.length - activeOnPage]].map(([k, l, c]) => (
              <button key={k} className={`prm-chip ${statusFilter === k ? 'active' : ''}`} onClick={() => setStatusFilter(k)}>
                {l} <span className="count">{c}</span>
              </button>
            ))}
          </div>
          {searchTerm && <span className="prm-tag amber">Search: “{searchTerm}”</span>}
        </div>
        <div className="prm-toolbar-right">
          <span className="prm-result-count">Showing <b>{visible.length}</b> of {totalCustomers}</span>
          <div className="prm-layout-toggle">
            <button className={layout === 'cards' ? 'active' : ''} onClick={() => setLayout('cards')} title="Card view"><Icon name="grid" size={17} /></button>
            <button className={layout === 'table' ? 'active' : ''} onClick={() => setLayout('table')} title="Table view"><Icon name="list" size={17} /></button>
          </div>
        </div>
      </div>

      {/* LIST */}
      <div className={loading ? 'cr-loading' : ''}>
        {visible.length === 0 && !loading ? (
          <div className="prm-empty">
            <div className="icon"><Icon name={searchTerm || statusFilter !== 'all' ? 'search' : 'users'} size={44} /></div>
            <h3>{searchTerm || statusFilter !== 'all' ? 'No customers match your search' : 'No customers yet'}</h3>
            <p>{searchTerm || statusFilter !== 'all' ? 'Try a different search term or clear the filters.' : 'Registered customers will appear here.'}</p>
            {(searchTerm || statusFilter !== 'all') && <button className="prm-btn ghost" onClick={handleRefresh}>Clear filters</button>}
          </div>
        ) : layout === 'cards' ? (
          <div className="prm-grid">
            {visible.map((c, i) => <CustomerCard key={c.id} c={c} index={i} onView={setViewingCustomer} onEdit={openEdit} />)}
          </div>
        ) : (
          <div className="prm-table-wrap">
            <table className="prm-table">
              <thead>
                <tr><th>No.</th><th>Customer</th><th>Phone</th><th>Bookings</th><th>Joined</th><th>Status</th><th>Actions</th></tr>
              </thead>
              <tbody>
                {visible.map((c, i) => (
                  <tr key={c.id} style={{ animationDelay: `${i * 50}ms` }}>
                    <td>{c.serialNo}</td>
                    <td>
                      <div className="pbo-cell-owner">
                        <Avatar name={c.name} src={imgUrl(c.profileImage)} />
                        <div><div className="name">{c.name || 'N/A'}</div><div className="sub">{c.email || 'N/A'}</div></div>
                      </div>
                    </td>
                    <td>{c.phone || 'N/A'}</td>
                    <td><span className="pbo-count">{c.bookingsCount}</span></td>
                    <td>{c.joined}</td>
                    <td><span className={`prm-status ${c.status === 'Active' ? 'active' : 'inactive'}`}>{c.status}</span></td>
                    <td>
                      <div className="prm-row-actions">
                        {/* className="prm-btn view sm" */}
                        <button className="prm-btn view sm icon-only" onClick={() => setViewingCustomer(c)} title="View" aria-label="View"><Icon name="eye" size={14} /></button>
                        <button className="prm-btn ghost sm icon-only" onClick={() => openEdit(c)} title="Edit" aria-label="Edit"><Icon name="edit" size={14} /></button>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* PAGINATION — always visible */}
      <Pagination
        page={currentPage} pageSize={pageSize} total={totalCustomers}
        onPage={(p) => setCurrentPage(Math.min(Math.max(1, p), totalPages))}
        onPageSize={(s) => { setPageSize(s); setCurrentPage(1); }}
        sizes={[10, 25, 50, 100]} label="customers"
      />

      {/* EDIT MODAL */}
      {editing && (
        <div className="prm-overlay" onClick={() => setEditing(null)}>
          <div className="prm-form-modal prm-form-modal-sm" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <span className="prm-form-badge"><Icon name="edit" size={22} /></span>
                <div><h3>Edit customer</h3><p>{editing.email || editing.name}</p></div>
              </div>
              <button className="prm-modal-close" onClick={() => setEditing(null)}>×</button>
            </div>
            <div className="prm-form-body">
              <div className="prm-fgrid">
                <Field label="Name" required><input className="prm-input" value={editForm.name || ''} onChange={(e) => setEditForm(p => ({ ...p, name: e.target.value }))} /></Field>
                <Field label="Status">
                  <select className="prm-input prm-select" value={editForm.status || 'Active'} onChange={(e) => setEditForm(p => ({ ...p, status: e.target.value }))}>
                    <option value="Active">Active</option>
                    <option value="Inactive">Inactive</option>
                  </select>
                </Field>
                <Field label="Email"><input type="email" className="prm-input" value={editForm.email || ''} onChange={(e) => setEditForm(p => ({ ...p, email: e.target.value }))} /></Field>
                <Field label="Phone"><input className="prm-input" value={editForm.phone || ''} onChange={(e) => setEditForm(p => ({ ...p, phone: e.target.value }))} /></Field>
              </div>
            </div>
            <div className="prm-form-foot">
              <span className="prm-foot-hint">Fields marked <em>*</em> are required</span>
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => setEditing(null)}>Cancel</button>
                <button className="prm-btn primary" onClick={handleSaveEdit} disabled={saving}>{saving ? 'Saving…' : 'Save changes'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* VIEW MODAL */}
      {viewingCustomer && (
        <div className="prm-overlay" onClick={() => setViewingCustomer(null)}>
          <div className="prm-form-modal pbo-fleet" onClick={(e) => e.stopPropagation()}>
            <div className="prm-form-head">
              <div className="prm-form-head-row">
                <Avatar name={viewingCustomer.name} src={imgUrl(viewingCustomer.profileImage)} size={52} />
                <div>
                  <h3>{viewingCustomer.name || 'Customer'}</h3>
                  <p>{viewingCustomer.email || 'N/A'} · {viewingCustomer.phone || 'N/A'}</p>
                </div>
              </div>
              <button className="prm-modal-close" onClick={() => setViewingCustomer(null)}>×</button>
            </div>

            <div className="prm-form-body">
              <div className="pbo-mini-stats">
                <div><span>Status</span><b className={viewingCustomer.status === 'Active' ? 'cr-ok' : 'cr-off'}>{viewingCustomer.status}</b></div>
                <div><span>Joined</span><b>{viewingCustomer.joined}</b></div>
                <div><span>Wallet</span><b>{formatCurrency(viewingCustomer.walletBalance)}</b></div>
                <div><span>Total bookings</span><b>{viewingCustomer.bookingsCount || 0}</b></div>
              </div>

              <div className="prm-section-title">Customer bookings ({viewingCustomer.bookingsCount || 0})</div>

              {bookings.length > 0 ? (
                <>
                  <div className="cr-summary">
                    <div><Icon name="ticket" size={16} /> <span>Bookings</span><b>{bookings.length}</b></div>
                    <div><Icon name="wallet" size={16} /> <span>Total amount</span><b>{formatCurrency(bookingTotal)}</b></div>
                    <div><Icon name="check" size={16} /> <span>Confirmed</span><b>{bookingConfirmed}</b></div>
                  </div>

                  <div className="cr-bookings">
                    {bookings.map((b, i) => (
                      <div key={b._id || i} className="cr-booking" style={{ animationDelay: `${i * 50}ms` }}>
                        <div className="cr-booking-head">
                          <span className="pbo-plate">{b.pnr || 'N/A'}</span>
                          <div className="cr-booking-badges">
                            <StatusPill value={b.status} />
                            <StatusPill value={b.paymentStatus} />
                          </div>
                        </div>
                        <div className="cr-booking-grid">
                          <div>
                            <small>Journey</small>
                            <b>{formatDateDMY(b.journeyDate)}</b>
                            <span>{getJourneyTime(b)}</span>
                          </div>
                          <div>
                            <small>Booked on</small>
                            <b>{formatDateDMY(b.createdAt)}</b>
                            <span>{formatTimeHM(b.createdAt)}</span>
                          </div>
                          <div>
                            <small>Bus</small>
                            <b>{b.bus?.busName || 'N/A'}</b>
                            <span>{[b.bus?.busNumber, b.bus?.busType].filter(Boolean).join(' · ')}</span>
                          </div>
                          <div>
                            <small>Route</small>
                            <b>{b.route?.routeName || 'N/A'}</b>
                            {b.route?.origin && (
                              <span>{b.route.origin.city || b.route.origin} → {b.route.destination?.city || b.route.destination}</span>
                            )}
                          </div>
                          <div>
                            <small>Seats</small>
                            <div className="pbo-chips">
                              {b.seats?.slice(0, 3).map((s, k) => <span key={k} className="prm-tag navy">{s.seatNumber}</span>)}
                              {b.seats?.length > 3 && <span className="prm-tag gray">+{b.seats.length - 3} more</span>}
                              {!b.seats?.length && <span className="pbo-muted">—</span>}
                            </div>
                          </div>
                          <div>
                            <small>Amount</small>
                            {b.pricing ? (<><b>{formatCurrency(b.pricing.payableAmount)}</b><span>Total: {formatCurrency(b.pricing.totalAmount)}</span></>) : <b>N/A</b>}
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                <div className="prm-empty" style={{ margin: 0 }}>
                  <div className="icon"><Icon name="ticket" size={44} /></div>
                  <h3>No bookings found</h3>
                  <p>This customer hasn’t made any bookings yet.</p>
                </div>
              )}
            </div>

            <div className="prm-form-foot">
              <span />
              <div className="prm-form-foot-actions">
                <button className="prm-btn ghost" onClick={() => { const c = viewingCustomer; setViewingCustomer(null); openEdit(c); }}><Icon name="edit" size={15} /> Edit</button>
                <button className="prm-btn primary" onClick={() => setViewingCustomer(null)}>Close</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomerReport;